import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SedsFormFieldType } from '../../seds-form-field/enums/seds-form-field-type.enum';
import { SedsThemeColorOptions } from '../../../shared/enums/seds-theme-color-options.enum';
import { SedsThemeColorOptionsType } from '../../../shared/types/seds-theme-color-options.type';

@Component({
    selector: 'seds-search, seds-form-field-search',
    templateUrl: './seds-form-field-search.component.html',
    styleUrls: ['./seds-form-field-search.component.scss'],
    standalone: false
})
export class SedsFormFieldSearchComponent {
  iconName = 'search';
  type = SedsFormFieldType.SEARCH;

  @Input() color?: SedsThemeColorOptions | SedsThemeColorOptionsType = SedsThemeColorOptions.DEFAULT;
  @Input() label!: string;
  @Input() placeholder = '';

  @Output() search = new EventEmitter<string>();

  send(value: string) {
    this.search.emit(value);
  }
}
